var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',{staticClass:"mb-2",attrs:{"sub-title":_vm.group.label}},_vm._l((_vm.group.fields),function(field,idx){return _c('b-form-group',{key:idx},[_c('form-field',{attrs:{"parent":_vm.group,"field":field},model:{value:(field.value),callback:function ($$v) {_vm.$set(field, "value", $$v)},expression:"field.value"}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }